import React, { useEffect, useState } from 'react';
import { DateTime } from "luxon";
import { DISPLAY_TIME_ZONE, DISPLAY_TIME_ZONE_LABEL } from '../utilities/time';

export default function Clock() {
  const [time, setTime] = useState(DateTime.now().setZone(DISPLAY_TIME_ZONE))
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(DateTime.now().setZone(DISPLAY_TIME_ZONE))
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>{time.toFormat('hh:mm:ss a')} {DISPLAY_TIME_ZONE_LABEL}</>
  )
}